import { create } from "zustand";

export const useSidebarStore = create((set) => ({
    showBlastStatistics: false,
    toggleComponent: () => set((state) => ({ showBlastStatistics: !state.showBlastStatistics })),
  }));
  